import { render, staticRenderFns } from "./delete-admin.vue?vue&type=template&id=25d8b088&"
import script from "./delete-admin.vue?vue&type=script&lang=js&"
export * from "./delete-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports